import PlatformHelper from '@sport1/react-elements/PlatformHelper'
import LightTheme from '../../themes/LightTheme'

type Link = {
    textContent: string
    type: 'LINK'
    onPress: () => void
}

type Text = {
    type: 'TEXT'
    textContent: string
}

export type TextObject = Link | Text

type TextDecoration =
    | { textDecorationLine: 'underline'; textDecorationColor?: string }
    | { textDecorationLine?: 'underline'; textDecorationColor?: never }

export type FloatingTextObject = {
    textStyle: {
        fontSize: string
        lineHeight: string
        fontFamily: 'Sport1-Regular'
        color?: string
        textAlign?: 'center'
    } & TextDecoration
    content: string
    onPress?: () => void
}

export const getTextContents = (textObjects: TextObject[]): FloatingTextObject[] => {
    const isSmallDevice = PlatformHelper.getDimensions().width < 360
    const fontSize = isSmallDevice ? LightTheme.fontSizes['FS12'] : LightTheme.fontSizes['FS14']
    const lineHeight = isSmallDevice
        ? LightTheme.lineHeights['LH14']
        : LightTheme.lineHeights['LH20']

    const textContents: FloatingTextObject[] = []

    textObjects.forEach(textObject => {
        if (textObject.type === 'TEXT') {
            textContents.push({
                content: textObject.textContent,
                textStyle: {
                    fontSize,
                    lineHeight,
                    fontFamily: 'Sport1-Regular',
                    color: 'onyx',
                    textAlign: 'center',
                },
            })
        } else {
            textContents.push({
                content: textObject.textContent,
                textStyle: {
                    fontSize,
                    lineHeight,
                    fontFamily: 'Sport1-Regular',
                    color: 'onyx',
                    textAlign: 'center',
                    textDecorationLine: 'underline',
                    textDecorationColor: 'onyx',
                },
                onPress: textObject.onPress,
            })
        }
    })

    return textContents
}
